function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1f {\n        fill: none;\n      }\n\n      .cls-2f {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-3f {\n        fill: #fb3147;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Clip_2",
  "data-name": "Clip 2",
  className: "cls-1f",
  d: "M0,0H16.736V34.69H0Z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "ic_journee_alerte",
  className: "cls-2f"
}, /*#__PURE__*/React.createElement("path", {
  id: "Fill_1",
  "data-name": "Fill 1",
  className: "cls-3f",
  d: "M15.116.01C14.695-.316,6.786,7.319.983,14.391c0,0-1.474,1.746-.812,2.4.572.564,7.277,2.516,7.548,3.492.146.527-6.555,14.471-6.135,14.41S15,21.375,16.68,18.416c0,0,.48-.592-1.384-1.362s-6.555-2.723-6.555-2.723S15.5.31,15.116.01",
  transform: "translate(0 0)"
}));

var SvgAlerteRed = function SvgAlerteRed(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.736,
    height: 34.69,
    viewBox: "0 0 16.736 34.69",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlerteRed, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alerte_red.24b8a01d.svg";
export { ForwardRef as ReactComponent };